import {numberByWords, toUpperFirst as ToUpperFirst, wordByCount} from '../utils';

type Language = {
	id: string;
	title: string;
};

type LanguageItem = {
	language: Language | null;
	parts?: Language[]; // Если язык состоит из нескольких частей (например подъязыки для Primordial)
	plus?: number; // Количество дополнительных языков (всеобщий и еще 5 языков) *
	note?: string; // Комментарий в скобках, например can't speak in bear form
};

type UnderstandLanguage = {
	langs?: LanguageItem[]; // языки, которые понимают
	speechless?: boolean; // немой (cant speak THEM)
	commands?: boolean; // понимает команды
	your?: boolean; // понимает вас understands the languages you know
};

type Telepathy = {
	distance: string; // строка расстояния, 30 футов, 1 миля
	note?: string; // Комментарий в скобках - works only with you (нужен перевод)
};

function toLanguage(language: Language) {
	return language.id === 'all' ? 'все' : ToUpperFirst(language.title);
}

function toLanguageItem(languageItem: LanguageItem) {
	if (!languageItem.language) return null;

	let result = toLanguage(languageItem.language);
	if (languageItem.parts) result += ` (${languageItem.parts.map(toLanguage).join(', ')})`;
	// TODO: числительные
	if (languageItem.plus)
		result += ` плюс ${numberByWords(languageItem.plus)}\u00A0${wordByCount(languageItem.plus, [
			'язык',
			'языка',
			'языков',
		])}`;

	if (languageItem.note) result += ` (${languageItem.note})`;

	return result;
}

export function toMonsterLanguages(
	languages: LanguageItem[],
	understandLanguages: UnderstandLanguage,
	telepathy: Telepathy,
) {
	let items: string[] = [];

	if (languages) {
		items = [languages.map(toLanguageItem).join(', ')];
	}

	if (understandLanguages) {
		let result = '';
		if (understandLanguages.your) {
			result = 'понимает языки, которые вы\u00A0знаете';
		} else {
			result = 'понимает ';
			if (understandLanguages.langs) result = understandLanguages.langs.map(toLanguageItem).sort().join(', ');
			if (understandLanguages.commands) result += 'команды';
		}
		if (understandLanguages.speechless) result += ', но\u00A0не\u00A0говорит';
		/*else
			result += `, но не может на ${
				(understandLanguages.langs || []).length > 1 || understandLanguages.your ? 'них' : 'нём'
			} говорить`;*/

		items.push(result);
	}

	if (telepathy?.distance) {
		let result = `телепатия ${telepathy.distance}`;
		if (telepathy.note) result += ` (${telepathy.note})`;

		items.push(result);
	}

	return items.sort().join('; ');
}
